import '@doltech/ui/lib/antd/css/dol.theme.global.css';
import '@doltech/ui/lib/antd/css/landing.theme.global.css';

import { withAppScroll } from '@doltech/core/lib/appScroll/withAppScroll';
import { withEncryptedData } from '@doltech/core/lib/encrypt-page-data/withEncryptedData';
import { withReactQueryConfig } from '@doltech/core/lib/hooks/withReactQueryConfig';
import { withDolSystemDesignThemeProvider } from '@doltech/ui/lib/figma/Common/theme';
import { withLandingSharedLayout } from '@doltech/ui/lib/figma/Layout/Landing/hocs/withLandingSharedLayout';
import {
  useTrackingLastUrlAndAutoScrollToTop,
  withDolSetup,
} from '@doltech/ui/lib/hocs/withDolSetup';
import { withUpdateViewCount } from '@doltech/ui/lib/hocs/withUpdateViewCount';
import { compose } from '@doltech/utils/lib/compose';
import { initNumeralConfig } from '@doltech/utils/lib/numeral-config';
import { AppProps } from 'next/app';
import * as React from 'react';
import { bootstrapBrowserAuthManager } from '../bootstrapBrowserAuthManager';
import { isBrowser } from '@doltech/utils/lib/platform';
import { withGTMPageContext } from '@doltech/core/lib/hooks/gtm/withGTMPageContext';
import { withGTM } from '@doltech/core/lib/hooks/gtm/withGTM';
import { environment } from '@doltech/core/lib/environment/environment';
import { withSimpleAudioPlayInBackground } from '@doltech/ui/lib/hooks/simple-audio-play-in-background.store';
import { withGlobalModalPortal } from '@doltech/ui/lib/hocs/withGlobalModalPortal';
//
initNumeralConfig();
if (isBrowser()) {
  bootstrapBrowserAuthManager();
}

interface CustomAppProps extends Omit<AppProps, 'Component'> {
  err: any;
  Component: any;
}

function CustomApp({ Component, pageProps }: CustomAppProps) {
  useTrackingLastUrlAndAutoScrollToTop();

  return <Component {...pageProps} />;
}

export default compose(
  withEncryptedData,
  withGTM({
    gtmId: 'GTM-W2L6RPB',
    env: [environment.REACT_APP_ENV],
  }),
  withReactQueryConfig,
  withDolSystemDesignThemeProvider,
  withAppScroll({
    getAppScrollElement: () => window,
    getAppContainer: () => document.getElementById('app-root'),
  }),
  withGTMPageContext({ showMessengerButton: true }),
  withUpdateViewCount,
  withLandingSharedLayout,
  withSimpleAudioPlayInBackground,
  withDolSetup({
    renderMeta: () => null,
  }),
  withGlobalModalPortal
)(CustomApp);
